// extracted by mini-css-extract-plugin
export var About = "style-module--About--D2YAT";
export var Description = "style-module--Description--LgGZH";
export var Image = "style-module--Image--V-O8y";
export var ImageWrapper = "style-module--ImageWrapper--pBujx";